module.exports = __webpack_public_path__ + "static/img/logo12.00c2a09.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo12.png
// module id = XUyf
// module chunks = 1